const EMPTY_WORKSPACE_LOCATION = Object.freeze({ projectId: '', sessionId: '' });

function cleanText(value) {
  return String(value || '').trim();
}

function resolveStorage(storage) {
  if (storage !== undefined) {
    return storage;
  }
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

function normalizeWorkspaceLocation(value = {}) {
  const source = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  const projectId = cleanText(source.projectId);
  return {
    projectId,
    sessionId: projectId ? cleanText(source.sessionId) : '',
  };
}

export function resolveWorkspaceLocationStorageKey({ instanceId = '', userId = '' } = {}) {
  const instance = cleanText(instanceId);
  const user = cleanText(userId);
  return instance && user ? `flare:workspace-location:${instance}:${user}` : '';
}

export function readWorkspaceLocation(identity = {}, { storage } = {}) {
  const storageKey = resolveWorkspaceLocationStorageKey(identity);
  const targetStorage = resolveStorage(storage);
  if (!storageKey || !targetStorage) {
    return { ...EMPTY_WORKSPACE_LOCATION };
  }
  try {
    return normalizeWorkspaceLocation(JSON.parse(targetStorage.getItem(storageKey) || '{}'));
  } catch {
    return { ...EMPTY_WORKSPACE_LOCATION };
  }
}

export function saveWorkspaceLocation(identity = {}, location = {}, { storage } = {}) {
  const storageKey = resolveWorkspaceLocationStorageKey(identity);
  const targetStorage = resolveStorage(storage);
  if (!storageKey || !targetStorage) {
    return false;
  }
  const normalized = normalizeWorkspaceLocation(location);
  try {
    if (!normalized.projectId) {
      targetStorage.removeItem(storageKey);
    } else {
      targetStorage.setItem(storageKey, JSON.stringify(normalized));
    }
    return true;
  } catch {
    return false;
  }
}

export function clearWorkspaceLocation(identity = {}, options = {}) {
  return saveWorkspaceLocation(identity, EMPTY_WORKSPACE_LOCATION, options);
}
